goog.provide('el8.appchart.mgr.notes');

goog.require('el8.appchart.refpanel.meds');
goog.require('el8.appservice.notifier');
goog.require('el8.appchart.cqmRefresh');
goog.require('el8.data.base');
goog.require('el8.practicedata.appts');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.historyItems');
goog.require('el8.ptdata.model.note.visit');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.base');
goog.require('el8.util.consts');

el8.appchart.mgr.notes = (function() {

    // Constructor functions for notes, initialized in init()
    var visitNoteMain = null;
    var nonvisitNoteMain = null;

    // Tracking state
    var hasVitalsNotes = {};

    return {

        init: function(spec) {
            visitNoteMain = spec.visitNote;
            nonvisitNoteMain = spec.nonvisitNote;
        },

        closeOpenVisitNote: function() {
            if (visitNoteMain.isOpen()) {
                visitNoteMain.close();
            }
        },

        disableVisitNote: function() {
            if (visitNoteMain && visitNoteMain.isOpen()) {
                visitNoteMain.disable()
            }
        },

        enableVisitNote: function() {
            if (visitNoteMain && visitNoteMain.isOpen()) {
                visitNoteMain.enable()
            }
        },

        showVisitNote: function(spec) {
            var that = this;

            spec = spec || {};
            var callbackFn = spec['callbackFn'] || null;

            el8.appchart.mgr.thirdpane.close();

            // If a note is passed in, close anything existing and open that note
            if (spec.note) {
                this._displayExistingVisitNote(spec.note);
                if (callbackFn) { callbackFn(visitNoteMain); }

            // Else if asked to force existing
            } else if (spec.forceExisting) {
                if (visitNoteMain.isOpen()) {
                    el8.appservice.notifier.notify('Displaying open visit note.');
                    if (callbackFn) { callbackFn(visitNoteMain); }

                } else {
                    var unsignedNotes = el8.ptdata.visitNotes.getUnsigned();
                    if (unsignedNotes.length) {
                        el8.appservice.notifier.notify('Existing in progress visit note found!  Displaying unfinished note...');
                        this._showUnsignedVisitNote(unsignedNotes[0]);
                        if (callbackFn) { callbackFn(visitNoteMain); }

                    } else {
                        el8.appservice.notifier.notify('Opening new visit note...');
                        this._createNewVisitNote(spec);
                    }
                }

            // The non-forceExisting branch. E.g. from scheduler or from create new note menu
            } else {

                var unsignedNotes = el8.ptdata.visitNotes.getUnsigned();
                var unsignedNote = unsignedNotes[0];
                var appointmentId = el8.util.getUrlParam('appointment_id');
                var appointmentVisitNote;
                var isSchedulerAppointment = appointmentId && spec.schedulerAutoOpen;

                if (isSchedulerAppointment) {
                    // if has existing visit note with matching appointment_id query param
                    // and url loaded with an appointment_id query param
                    appointmentVisitNote = unsignedNotes.find(function (note) {
                        return note.getAppointmentId() === Number(appointmentId)
                    })
                }

                if (appointmentVisitNote) {
                        that._displayExistingVisitNote(appointmentVisitNote);
                        if (callbackFn) { callbackFn(visitNoteMain); }
                }  else if (unsignedNote && !unsignedNote.getAppointmentId()) {
                    if (isSchedulerAppointment) {
                        var appointment = el8.practicedata.appts.getById(appointmentId);
                        el8.uiwidget.confirm('Would you like to open the in-progress note dated '
                                + '"'
                                + unsignedNote.getDocumentDate().asDateTimeString()
                                + '"'
                                + ' and update the date & time to match '
                                + appointment.getPatientName()
                                + "'s "
                                + 'appointment for '
                                + '"'
                                + appointment.getApptTime().asDateTimeString()
                                + '"'
                                + ' or create a new visit note?',
                            function() {
                                that.applyAppointmentAutomation(unsignedNote, appointmentId, function (automatedUnsignedNote) {
                                    that._displayExistingVisitNote(automatedUnsignedNote);
                                });
                                if (callbackFn) { callbackFn(visitNoteMain); }
                            },
                            function() {
                                if (visitNoteMain.isOpen()) { visitNoteMain.close(); }
                                that._createNewVisitNote(spec);
                            },
                            {
                                customBtnOpts: {
                                    text: 'Close',
                                },
                                noBtnText: 'Create New',
                                prefHeight: 250,
                                title: 'There is a visit note in progress',
                                yesBtnText: 'Update In-Progress Note'
                            }
                        );
                    } else {
                        var title = spec.noteSelectionDialogTitle || 'There is a visit note in progress';
                        el8.uiwidget.confirm('Would you like to open the in-progress note dated ' + '"' + unsignedNote.getDocumentDate().asDateTimeString() + '"' + ' or create a new visit note?',
                            function() {
                                that._displayExistingVisitNote(unsignedNote);
                                if (callbackFn) { callbackFn(visitNoteMain); }
                            },
                            function() {
                                if (visitNoteMain.isOpen()) { visitNoteMain.close(); }
                                that._createNewVisitNote(spec);
                            },
                            {
                                title: title,
                                yesBtnText: 'Open In-Progress Note',
                                noBtnText: 'Create New',
                            }
                        );
                    }
                } else {
                    el8.appservice.notifier.notify('Opening new visit note...');
                    this._createNewVisitNote(spec);
                }

            } // non-forceExisting
        },

        applyAppointmentAutomation: function(unsignedNote, appointmentId, callbackFn) {
            var data = {'appointment_id': appointmentId};
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH'] + 'visit-notes/' + unsignedNote.getId() + '/apply-automation/',
                async: false,
                data: JSON.stringify(data),
                success: function (data) {
                    unsignedNote = el8.ptdata.visitNotes.create(data);
                    el8.appservice.notifier.notify('Visit note automation applied');
                    if (callbackFn) { callbackFn(unsignedNote); }
                },
            });
        },

        cloneExistingNote: function(noteId, opts) {
            this.closeOpenVisitNote(); // won't do anything if none are open
            var cloneHPIOnly = Boolean(opts && opts.hpiOnly);
            this._createNewVisitNote({
                cloneNoteId: noteId,
                cloneHPIOnly: cloneHPIOnly,
            });
            el8.util.amplitude.logEvent('Export Note', 
                {
                    'Doc Id': noteId, 
                    'Type': cloneHPIOnly ? 'New Note (HPI Only)' : 'New Note',
                });
        },

        visitNoteIsShowing: function() {
            return visitNoteMain.isOpen();
        },

        someNoteIsShowing: function() {
            return visitNoteMain.isOpen() || nonvisitNoteMain.isOpen();
        },

        onBillUpdate: function(updatedNoteId) {
            if (this.visitNoteIsShowing() && visitNoteMain.getNoteId() === updatedNoteId) {
                visitNoteMain.renderUpdatedBill(updatedNoteId);
            }
        },

        getNoteDate: function() {
            return visitNoteMain.getNoteDate();
        },

        _displayExistingVisitNote: function(note) {
            if (visitNoteMain.isOpen()) {
                if (visitNoteMain.getNoteId() === note.getId()) {
                    if (!el8.appchart.layout.isThirdPaneVisible()) {
                        // note is "open" but off screen
                        el8.appchart.layout.displayForm();
                    } else {
                        el8.appservice.notifier.notify('Visit note is already open.');
                    }
                } else {
                    el8.appservice.notifier.notify('Closing current visit note and displaying requested visit note...');
                    visitNoteMain.close();
                    this._showUnsignedVisitNote(note);
                }
            } else {
                el8.appservice.notifier.notify('Displaying requested visit note...');
                this._showUnsignedVisitNote(note);
            }
        },

        _showUnsignedVisitNote: function(unsignedNote) {
            /* This will only remove preview if there is a previewed item and ID matches */
            var year = unsignedNote.getDocumentDate().year;
            el8.appchart.cqmRefresh.setReportingYear(year);
            el8.appchart.cqmRefresh.forceRefresh(true);
            el8.appchart.mainFeeds.chart.removePreview(unsignedNote.getId());
            visitNoteMain.show(unsignedNote);
        },

        _createNewVisitNote: function(opts) {
            el8.appservice.notifier.notify('Creating new visit note...');

            var data = {};
            if (opts.cloneNoteId) {
                data['clone_note_id'] = opts.cloneNoteId;
            } else {
                data['template'] = opts.templateType || null;
            }
            if (opts.cloneNoteId) {
                data['clone_note_id'] = opts.cloneNoteId;
                data['clone_hpi_only'] = opts.cloneHPIOnly;
            }
            if (opts.visitNoteTypeId)  { data['visit_note_type_id'] = opts.visitNoteTypeId; }

            var appointmentId = el8.util.getUrlParam('appointment_id');
            if (opts.schedulerAutoOpen && appointmentId) {
                data['appointment_id'] = appointmentId;
            }

            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+"visit-notes/request-new/",
                async: false,
                data: JSON.stringify(data),
                success: function(data, textStatus, xhr) {
                    var newNote = el8.ptdata.visitNotes.create(data['note'], true);
                    var showNoteFn = function() {
                        el8.appservice.notifier.notify('New visit note displayed.');
                        visitNoteMain.show(newNote, { source: opts.uiSource, isNew: true });
                        if (opts.callbackFn) { opts.callbackFn(visitNoteMain); }
                    };

                    var suggestedDate = (data['suggested_date']) ?
                        el8.service.tz.toTzDateTime(data['suggested_date']) : null;

                    var alreadyLinkedToAppointment = Boolean(newNote.getAppointmentId());
                    if (alreadyLinkedToAppointment || (!suggestedDate || el8.util.datecompare.isToday(suggestedDate))) {
                        showNoteFn();
                    } else {
                        el8.uiwidget.confirm('This will link the visit note to the ' + '"' + suggestedDate.asDateTimeString() + '"'+
                        ' appointment.',
                            function() {
                                newNote.saveDocumentDate(suggestedDate, function() {
                                    visitNoteMain.updateVisitDateElt();
                                });
                                showNoteFn();
                            },
                            showNoteFn,
                            {
                                title: 'Link visit note to recent appointment?',
                                yesBtnText: 'Yes, link note to appointment',
                                noBtnText: 'No, do not link',
                                prefHeight: 240
                            }
                        );
                    }
                    el8.ptdata.visitNotes.trigger(EVENTS.CREATED, newNote); // Event was deferred in the create() call above
                }
            });
        },

        getOpenNoteId: function() {
          if (visitNoteMain.isOpen()) {
              return visitNoteMain.getNoteId();
          } else if (nonvisitNoteMain.isOpen()) {
              return nonvisitNoteMain.getOpenNoteId();
          }
        },

        isOpenNoteAmendment: function() {
          return visitNoteMain.isOpen() && visitNoteMain.isAmendment();
        },

        amendVisitNote: function(note) {

            el8.appchart.mgr.thirdpane.close();

            if (visitNoteMain.isOpen()) {
                el8.appservice.notifier.notify('Closing current visit note and opening new visit note...');
                visitNoteMain.close();
            }
            el8.appservice.notifier.notify('Displaying form to amend note...');
            if (!note.getCurrentEditId()) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8Globals['PATIENT_PATH']+"visit-notes/"+note.getId()+"/request-edit/",
                    async: false,
                    success: function(data, textStatus, xhr) {
                        note.setCurrentEditId(data.id);
                    }
                });
            }
            visitNoteMain.show(note);

            /* This will only remove preview if there is a previewed item and ID matches */
            el8.appchart.mainFeeds.chart.removePreview(note.getId());

            el8.appchart.mainFeeds.reqAct.update();
        },

        showNonvisitNote: function(spec) {
            spec = spec || {};
            if (spec.note) {
                if (nonvisitNoteMain.isOpen()) {
                    if (nonvisitNoteMain.getOpenNoteId() === spec.note.getId()) {
                        if (spec.callbackFn) { spec.callbackFn(); }
                        return; // we're all set
                    } else {
                        nonvisitNoteMain.saveDraftNote();
                    }
                }
                nonvisitNoteMain.show(spec.note);
                if (spec.callbackFn) { spec.callbackFn(); }
            } else {
                if (nonvisitNoteMain.isOpen()) {
                    el8.appservice.notifier.notify('Note is already open.');
                    return;
                }
                this._createNewNonvisitNote(spec);
                if (spec.callbackFn) { spec.callbackFn(); }
            }
        },

        showNoteId: function(spec) {
            var modelClass = el8.model.idToModelClass(spec.noteId);
            if (modelClass === 'VisitNote') {
                var noteItem = el8.ptdata.visitNotes.getById(spec.noteId);
                this.showVisitNote({ note: noteItem, callbackFn: spec.callbackFn });
            } else if (modelClass === 'NonvisitNote') {
                var noteItem = el8.ptdata.nonvisitNotes.getById(spec.noteId);
                this.showNonvisitNote({ note: noteItem, callbackFn: spec.callbackFn});
            }
        },

        tryAmendVisitNote: function(note) {
            var that = this;
            if (note.getSignUserId() === el8.data.currUser.getId() && !note.isImportedNote()) {
                el8.uiwidget.confirm("You are about to make changes to a signed off note. All changes will be tracked and logged for auditing and legal purposes. Proceed?",
                    function() { that.amendVisitNote(note); }
                );
            }
        },

        _createNewNonvisitNote: function(spec) {
            el8.appservice.notifier.notify('Creating new note...');
            var type = spec ? spec.type : el8.util.consts.DEFAULT_NONVISITNOTE_TYPE;
            var typeId = el8.data.nonvisitNoteTypes.getByName(type).getId();
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+"nonvisit-notes/request-new/",
                data: {'data': JSON.stringify({'type_id': typeId})},
                async: false,
                success: function(data, textStatus, xhr) {
                    el8.appservice.notifier.notify('New note displayed.');
                    nonvisitNoteMain.show(el8.ptdata.model.note.nonvisit(data['note']));
                }
            });
        },

        /**
         * Handle routing an order update (LabOrder, MedOrder, ReferralOrder) 
         * to VN1, VN2, non-visit note, or chart feed.
         * @param {LabOrder | MedOrder | ReferralOrder} order
         */
        addNewOrder: function(order) {
            if (visitNoteMain.isOpen() && !visitNoteMain.isEdit()) {
                visitNoteMain.addNewOrder(order);
            } else if (nonvisitNoteMain.isOpen()) {
                nonvisitNoteMain.addNewOrder(order);
            } else {
                // We always need to resync after adding an order, but the addNewOrder
                // functions above do it as a successCb, to avoid displaying orders
                // in the chart feed that just haven't saved as part of a note yet
                el8.appchart.mainFeeds.chart.update();
            }

            // Signal order update to React
            if (order && order.rawData) {
                el8React.messenger.send('OrderUpdate', {
                    type: 'OrderUpdate',
                    payload: {
                        order: order.rawData,
                    }
                });
            }
        },

        addNewLetter: function(letter) {
            if (visitNoteMain.isOpen() && !visitNoteMain.isEdit()) {
                visitNoteMain.addReference({item: letter});
            } else if (nonvisitNoteMain.isOpen()) {
                nonvisitNoteMain.addReference({item: letter});
            }
        },

        quickAddNonvisitNote: function(text, docId, callbackFn) {
            var obj = null;
            if (docId) {
                var doc = el8.ptdata.fetch({fetchIds: docId});
                obj = $.extend({summary: doc.getNoteSummary()}, {id: docId});
            }
            var data = {
                note_type_id: el8.data.nonvisitNoteTypes.getByName(el8.util.consts.DEFAULT_NONVISITNOTE_TYPE).getId(),
                text: text,
                entities: obj ? [obj] : null
            };
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'nonvisit-notes/request-complete/',
                data: {'data': JSON.stringify(data)},
                success: function(data) {
                    el8.ptdata.nonvisitNotes.create(data['note']);
                    el8.appchart.mainFeeds.chart.update();
                    if (callbackFn) { callbackFn(); }
                }
            });
        },

        addHandoutReference: function(handout) {
            if (visitNoteMain.isOpen()) {
                this.addReference({item: handout});
                visitNoteMain.markHandoutGiven(true);
            }
        },

        // MedlinePlus "handouts" are URLs, not real objects,
        // so we cannot rely on addReference and have to manually handle them
        addMedlineHandoutReference: function(name, url) {
            if (visitNoteMain.isOpen()) {
                var goalData = { 'text': 'Goal: ...' };
                var handoutData = { 'text': 'Patient Handout: ' + name + '; ' + url };
                visitNoteMain.addParentChild(goalData, handoutData, 'instr');

                visitNoteMain.markHandoutGiven(true);
            }
        },

        addReference: function(var_args) {
            if (visitNoteMain.isOpen()) {
                if (visitNoteMain.allowAddReference()) {
                    visitNoteMain.addReference.apply(visitNoteMain, arguments);
                } else {
                    el8.uiwidget.alert('This reference in note action cannot be done when amending a note.');
                }
            } else if (nonvisitNoteMain.isOpen()) {
                nonvisitNoteMain.addReference.apply(nonvisitNoteMain, arguments);
            } else {
                var args = arguments; // pinning arguments to this closure so callbackFn can use them
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: function() {
                        visitNoteMain.addReference.apply(visitNoteMain, args);
                    }
                });
            }
        },

        addText: function(var_args) {
            if (visitNoteMain.isOpen()) {
                if (visitNoteMain.allowAddReference()) {
                    visitNoteMain.addText.apply(visitNoteMain, arguments);
                } else {
                    el8.uiwidget.alert('This reference in note action cannot be done when a note is being amended.');
                }
            } else if (nonvisitNoteMain.isOpen()) {
                nonvisitNoteMain.addText.apply(nonvisitNoteMain, arguments);
            } else {
                var args = arguments;
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: function() {
                        visitNoteMain.addText.apply(visitNoteMain, args);
                    }
                });
            }
        },

        removeBullet: function(bulletId) {
          if (visitNoteMain.isOpen()) {
              visitNoteMain.removeBullet.call(visitNoteMain, bulletId);
          }
        },

        useChecklistTemplate: function(var_args) {
            if (visitNoteMain.isOpen()) {
                visitNoteMain.useChecklistTemplate.apply(visitNoteMain, arguments);
            } else {
                var args = arguments;
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: function() {
                        visitNoteMain.useChecklistTemplate.apply(visitNoteMain, args);
                    }
                });
            }
        },

        addVitalsNote: function(numVisits) {
            if (numVisits > 0) {
                if (visitNoteMain.isOpen() && visitNoteMain.isTwoColComplex()) {
                    if (!hasVitalsNotes[visitNoteMain.getNoteId()]) {
                        this.addText('Vitals from last '+numVisits+' visits reviewed', 'data');
                        hasVitalsNotes[visitNoteMain.getNoteId()] = true;
                    }
                }
            }
        },

        addProblemSubBullet: function(var_args) {
            var args = arguments;
            this.doActiveNote(function(_noteMain) {
                _noteMain.addProblemSubBullet.apply(_noteMain, args);
            });
        },

        _addProblemToBill: function(ptProblem, opts) {
            if (ptProblem.getImoIds() && ptProblem.getImoIds().length) {
                el8.appchart.mgr.notes.appendBillingDiagnoses({
                    imoIds: ptProblem.getImoIds()
                }, opts);
            } else if (ptProblem.getIcd9Ids() && ptProblem.getIcd9Ids().length) {
                el8.appchart.mgr.notes.appendBillingDiagnoses({
                    icd9Ids: ptProblem.getIcd9Ids()
                }, opts);
            }
        },

        // FUTURE: RM-33533 - refactor bulk import problems to Bill 2.0 without `skipSave`
        _addProblemsToBill: function(ptProblems) {
            // Exclude problems without IMO/DX mappings to ensure correct skipSave logic
            var problemsWithDx = ptProblems.filter(function (ptProblem) {
                return ptProblem.getImoIds() && ptProblem.getImoIds().length;
            });

            problemsWithDx.forEach(function (ptProblem, index) {
              // Only save after the last problem has been added to the bill,
              // or we'll get bugs if we fire multiple saves and they return in
              // a different order from the order they were fired in.
              var skipSave = index < problemsWithDx.length - 1;
              this._addProblemToBill(ptProblem, { skipSave: skipSave });
            }.bind(this));
        },

        addProblemWithDetails: function(ptProblem) {

            var that = this;
            var refInVisitNote = function() {
                var fieldType = visitNoteMain.getAssessmentFieldType() || 'textarea';
                if (fieldType === 'multilist') {
                    visitNoteMain.addProblemWithDetails(ptProblem, 'assessment');
                } else {
                    visitNoteMain.addReference({
                        item: ptProblem,
                        text: ptProblem.getNoteSummaryWithDetails(true),
                        sectionName: 'assessment'
                    });
                }

                if (el8Globals.FEATURES.AutoImportBilling) {
                    that._addProblemToBill(ptProblem);
                }
            };

            if (visitNoteMain.isOpen()) {
                refInVisitNote();
            } else if (nonvisitNoteMain.isOpen()) {
                nonvisitNoteMain.addReference({
                    item: ptProblem,
                    text: ptProblem.getNoteSummaryWithDetails(false)
                });
            } else {
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: refInVisitNote
                });
            }
        },

        appendBillingDiagnoses: function(var_args) {
            if (visitNoteMain.isOpen() && !visitNoteMain.isEdit()) {
                visitNoteMain.appendBillingDiagnoses.apply(visitNoteMain, arguments);
            } else if (visitNoteMain.isEdit()) {
                el8.appservice.notifier.notify('The billing information cannot be edited when a note is being amended.');
            } else {
                var args = arguments;
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: function() {
                        visitNoteMain.appendBillingDiagnoses.apply(visitNoteMain, args);
                    }
                });
            }
        },

        doActiveNote: function(fn) {
            if (visitNoteMain.isOpen()) {
                fn.call(this, visitNoteMain);
            } else if (nonvisitNoteMain.isOpen()) {
                fn.call(this, nonvisitNoteMain);
            } else {
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: fn
                });
            }
        },

        addMedsListSnapshot: function(type) {
            if (visitNoteMain.isOpen() && !visitNoteMain.allowAddReference()) {
                el8.uiwidget.alert('Importing the current meds list cannot be done when amending a note.');
                return;
            }
            var meds = [];
            if (type instanceof Array) {
                for (var i=0; i<type.length; i++) {
                    meds.addArray(el8.appchart.refpanel.meds.getSectionItemsByName(type[i]));
                }
            } else {
                meds = el8.appchart.refpanel.meds.getSectionItemsByName(type);
            }
            if (meds.length > 0) {
                this.doActiveNote(function(_noteMain) {
                    if (_noteMain === visitNoteMain && visitNoteMain.isOpen()) {
                        // for unstructured visit note med sections, add a header explaining the med list type
                        var visitNoteName = _noteMain.getCurrFormTemplate().displayName;
                        if (visitNoteName === 'Simple Note' || visitNoteName === 'SOAP Note') {
                            var typeStr;
                            if (type instanceof Array) {
                                typeStr = 'Current Meds:';
                            } else {
                                typeStr = (type === 'perm-rx' ? 'Rx' : (type === 'perm-otc') ? 'OTC' : 'Recent') + ' Meds:';
                            }
                            _noteMain.addText(typeStr, 'med');
                        }
                    }
                    for (var i=0; i<meds.length; i++) {
                        if (meds[i].is('MedOrderThread')) {
                            _noteMain.addReference({item: meds[i].getLatestOrder(), noNotify: true });
                        } else {
                            _noteMain.addReference({item: meds[i], noNotify: true });
                        }
                    }
                el8.appservice.notifier.notify('Meds list snapshot imported to current note.' );
                });
            } else {
                el8.uiwidget.alert('No meds for snapshot.');
            }
        },

        addHistorySnapshot: function() {
            if (visitNoteMain.isOpen() && !visitNoteMain.allowAddReference()) {
                el8.uiwidget.alert('Importing history items cannot be done when amending a note.');
                return;
            }

            var that = this;
            var allItems = el8.ptdata.historyItems.getAll();
            var allFormCollections = el8.ptdata.clinicalFormCollections.all();
            var familyRelItems = el8.ptdata.ptFamilyRelationships.getAllItems();

            if (allItems.length > 0 || allFormCollections.length > 0 || el8.ptdata.currSmokingStatus || familyRelItems.length > 0) {
                var typesInOrder = ['past', 'surgical', 'family', 'social',
                    'cognitive', 'functional', 'habits', 'psychological', 'diet', 'exercise',
                    'immunization', 'maintenance', 'legal', 'consultation'];
                typesInOrder.forEach(function(historyType) {
                    // second param: we don't care if one section is empty
                    that.referenceHistorySection(historyType, false);
                });
                el8.appservice.notifier.notify('History items imported to current note.' );

            } else {
                el8.uiwidget.alert('No history items to import.');
            }
        },

        referenceHistorySection: function(historyType, alertIfEmpty) {
            this.doActiveNote(function(_noteMain) {
                var mapFn = function(a) {
                    _noteMain.addReference({item: a, noNotify: true});
                };
                var items = el8.ptdata.historyItems[historyType].sorted();
                if ((historyType === 'habits') && el8.ptdata.currSmokingStatus) {
                    items = [el8.ptdata.currSmokingStatus].concat(items);
                }
                if (historyType === 'family') {
                    items = el8.ptdata.ptFamilyRelationships.getAllItems().concat(items);
                }
                var relevantFormCollections = el8.ptdata.clinicalFormCollections.getCollectionsForHistoryType(historyType);
                if (relevantFormCollections) {
                  items = relevantFormCollections.concat(items);
                }
                if (items.length) {
                    items.map(mapFn);
                } else if (alertIfEmpty) {
                    el8.uiwidget.alert('No items to import.');
                }
            });
        },

        _referenceActiveItems: function(entitySet, entitySetDescription, sectionName) {
            if (visitNoteMain.isOpen() && !visitNoteMain.allowAddReference()) {
                el8.uiwidget.alert('Importing '+entitySetDescription+' cannot be done when amending a note.');
                return;
            }

            var that = this;
            this.doActiveNote(function(_noteMain) {
                if (entitySet.isDocumentedAsNone()) {
                    that.addText(entitySet.getDocumentedAsNoneSummary(), sectionName);
                } else {
                    var items = entitySet.getAllActive();
                    for (var i=0; i<items.length; i++) {
                        that.addReference({item: items[i], noNotify: true, sectionName: sectionName});
                    }
                }
            });
        },

        referenceAllergies: function(sectionName) {
            // The default here seems to be HPI instead of allergy, which feels off. Rather than
            // changing that generally, it's easier to change just the "reference all" behavior.
            sectionName = sectionName || 'allergies';
            this._referenceActiveItems(el8.ptdata.ptAllergies, 'allergies', sectionName);
        },
        referenceIntols: function(sectionName) {
            sectionName = sectionName || 'allergies';
            this._referenceActiveItems(el8.ptdata.ptIntolerances, 'intolerances', sectionName);
        },
        referenceProblems: function(sections) {
            // duplicating from _referenceActiveItems because the billing/synopses paths
            // don't go through that function
            if (visitNoteMain.isOpen() && !visitNoteMain.allowAddReference()) {
                el8.uiwidget.alert('Importing problems cannot be done when amending a note.');
                return;
            }

            var that = this;
            sections.forEach(function(sectionName) {
                // We'll only actually import the bill if AutoImportBilling is on.
                // The bill section is custom, because we're just adding ICD9s,
                // not the whole patient problem
                if (el8Globals.FEATURES.AutoImportBilling && sectionName === 'billing') {
                    that._addProblemsToBill(el8.ptdata.ptProblems.getAllActive());

                // Synopses are also treated as if they were a special section
                } else if (sectionName === 'synopses') {
                    el8.ptdata.ptProblems.getAllActive().forEach(function(ptProblem) {
                        that.addProblemWithDetails(ptProblem);
                    });

                } else {
                    that._referenceActiveItems(el8.ptdata.ptProblems, 'problems', sectionName);
                }
            });
        },

        notifyRefreshReport: function(reportId) {
            var report = el8.ptdata.fetchById(reportId);
            el8.appchart.dialog.reports.refreshItem(report);
        },

        clearHighlightResults: function() {
            el8.appchart.dialog.reports.clearHighlightResults();
        },

        markMedsReconciled: function(val) {
            if (visitNoteMain.isOpen()) {
                visitNoteMain.markMedsReconciled(val);
            }
        },

        markCurrentMedsDocumented: function(val, callbackFn) {
            if (visitNoteMain.isOpen()) {
                visitNoteMain.markCurrentMedsDocumented(val);
                if (callbackFn) { callbackFn(); }
            }
        },

        printMedsList: function() {
            if (visitNoteMain.isOpen()) {
                visitNoteMain.addText('Meds List printed and given to patient', 'tx');
            }
            window.open(el8Globals['PATIENT_PATH']+'print/meds-list/');
        },

        autoImportLabsProblems: function(spec) {
            if (!spec || !spec.type) { return; }
            var reportIdList = [];
            var resultIdList = [];
            var resultsReportId = null;
            if (spec.type === 'reports') {
                reportIdList = spec.reportIds;
            } else if (spec.type === 'results') {
                resultIdList = [spec.resultId];  // Restricted to be of length 1 for now, mostly because of edge case of no match
                resultsReportId = spec.reportId;
            }
            var doAutoImportFn = function() {
                $.el8_ajax({
                    url: el8.service.urls.get('autoImportLabsProblems'),
                    data: {'data': JSON.stringify({
                        'lab_report_ids': reportIdList,
                        'lab_result_ids': resultIdList
                    })},
                    success: function(data) {
                        el8.util.amplitude.logEvent('import lab values and problems into note');
                        var issuesMsg = '';
                        if (data['issues'].length) {
                            issuesMsg = data['issues'].map(function(a) { return a; }).join(' ');
                        }
                        el8.appservice.notifier.notify(issuesMsg || 'Importing labs and associated problems...');
                        var results = data['results'].map(function(obj) {
                            var labResults = [];
                            for (var i=0; i<obj.lab_results.length; i++) {
                                var report =
                                    el8.ptdata.fetchById(obj.lab_results[i]['report_id']*1);
                                var labResult =
                                    report.getResultRow(obj.lab_results[i]['result_id']*1);
                                labResults.push(labResult);
                            }
                            return {
                                problem: el8.ptdata.ptProblems.getById(obj['problem_id']*1),
                                labResults: labResults
                            };
                        });
                        // If no results
                        if (!results.length) {
                            if (reportIdList.length) {
                                el8.appservice.notifier.notify('Sorry, we weren\'t able to match any active problems based on the selected report'+(reportIdList.length>1 ? 's' : '')+'.');
                                for (var i=0; i<reportIdList.length; i++) {
                                    var report = el8.ptdata.fetchById(reportIdList[i]);
                                    visitNoteMain.addReference({item: report, isAutoGen: true, noNotify: true});
                                }
                            }
                            if (resultIdList.length && resultsReportId) {
                                var report = el8.ptdata.fetchById(resultsReportId);
                                visitNoteMain.addReference({item: report, isAutoGen: true, noNotify: true});
                                var result = report.getResultRow(resultIdList[0]);
                                that.addProblemSubBullet(result);
                            }
                        } else {
                            for (var j=0; j<results.length; j++) {
                                var skipSave = j !== results.length - 1;
                                visitNoteMain.autoImportProblemWithLabs(
                                    results[j].problem, results[j].labResults, { skipSave: skipSave });
                            }
                            el8.appservice.notifier.notify(issuesMsg || 'Labs and associated problems imported.');
                        }
                    }
                });
            };
            if (!visitNoteMain.isOpen()) {
                this.showVisitNote({
                    forceExisting: true,
                    callbackFn: doAutoImportFn
                });
            } else {
                doAutoImportFn();
            }
            var that = this;
        },

        /**
         * Apply Nabla Copilot transcription summary export to the current visit note draft (VN1). 
         * If no draft is open, prompt to open an in-progress or new note before applying.
         * @param {NablaTranscriptionSummary} eventData - Transcription summary payload from Nabla
         */
        applyNablaCopilotDraftContent: function(eventData) {
           var doNablaExport = function doNablaExport() {
               var noteId = visitNoteMain.getNoteId();
               console.log('[aiscribe] Exporting content to visit note ' + noteId);
               el8.appservice.notifier.notify('Exporting visit note content...');
   
               visitNoteMain.disable();
               
               $.el8_ajax({
                   type: 'POST',
                   url: el8.service.urls.get('exportDraftTranscriptionContent', [noteId, 'nabla']),
                   data: JSON.stringify(eventData),
                   success: function(visitNoteData) {
                       visitNoteMain.repopulate(visitNoteData);
                       el8.appservice.notifier.notify('Visit note content exported.');
                   },
                   error_override: function(_data) {
                       visitNoteMain.enable();
                   }
               });
           }
   
           if (visitNoteMain.isOpen()) {
               doNablaExport();
           } else {
               this.showVisitNote({
                   callbackFn: doNablaExport
               });
           }
       }
    };
})();
